import { render } from "./FormControl.vue?vue&type=template&id=35b5f496"
import script from "./FormControl.vue?vue&type=script&lang=js"
export * from "./FormControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__